export const GET_ALL_SEARCH = 'GET_ALL_SEARCH'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
